import { UserPermissionsState } from './state';
import {
  UserPermissionsActionsUnion,
  UserPermissionsActionTypes
} from './actions';

export const userPermissionsDefaultState: UserPermissionsState = {
  userPermissions: undefined,
  loaded: false,
  loading: false,
  error: undefined
};

export function userPermissionsReducer(
  state = userPermissionsDefaultState,
  action: UserPermissionsActionsUnion
): UserPermissionsState {
  switch (action.type) {
    case UserPermissionsActionTypes.SkipLoad:
      return {
        ...state,
        userPermissions: undefined,
        loaded: true,
        error: undefined
      };
    case UserPermissionsActionTypes.Load:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case UserPermissionsActionTypes.LoadSuccess:
      return {
        ...state,
        userPermissions: action.payload,
        loaded: true,
        loading: false,
        error: undefined
      };
    case UserPermissionsActionTypes.LoadFail:
      return {
        ...state,
        userPermissions: undefined,
        loaded: false,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
